import React from 'react';
import { FileText, Download, Clock } from 'lucide-react';
import './Reports.css';

const Reports = () => {
    const reports = [
        {
            id: 1,
            title: 'Monthly Financial Statement',
            lastGenerated: 'Oct 24, 2023',
            status: 'active'
        },
        {
            id: 2,
            title: 'Student Progress Report',
            lastGenerated: 'Oct 24, 2023',
            status: 'coming-soon'
        },
        {
            id: 3,
            title: 'Vehicle Maintenance Log',
            lastGenerated: 'Oct 24, 2023',
            status: 'coming-soon'
        },
        {
            id: 4,
            title: 'Instructor Performance Review',
            lastGenerated: 'Oct 24, 2023',
            status: 'active'
        }
    ];

    return (
        <div className="reports-page">
            <div className="reports-header">
                <h2>Generated Reports</h2>
            </div>

            <div className="reports-grid">
                {reports.map(report => (
                    <div
                        key={report.id}
                        className={`report-card ${report.status === 'coming-soon' ? 'coming-soon' : ''}`}
                    >
                        {report.status === 'coming-soon' && (
                            <div className="coming-soon-badge">
                                <Clock size={14} />
                                Coming Soon
                            </div>
                        )}

                        <div className="report-icon">
                            <FileText size={32} />
                        </div>

                        <div className="report-content">
                            <h3 className="report-title">{report.title}</h3>
                            <p className="report-date">Last generated: {report.lastGenerated}</p>
                        </div>

                        {report.status === 'active' ? (
                            <button className="download-btn">
                                <Download size={16} />
                                Download PDF
                            </button>
                        ) : (
                            <div className="coming-soon-text">
                                This report will be available soon
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Reports;
